<template>
  <div
    class="cart-fixed-button-warpper"
    v-if="cartCount!==0"
  >
    <div class="pricez">
      <span data-test="mobileCartTotalSpan"
												id="mobileCartTotalSpan">
        {{cartTotal | currencyConversion}}
      </span>
      <!--<span>View price details</span>-->
    </div>
    <button
      class="btn btn-primary cart-fixed-button"
      @click.prevent="$router.push('/checkout')"
      :disabled="outOfStock"
      :style="outOfStock? 'cursor: not-allowed;': ''"
						data-test="mobileCartContinueBtn"
						id="mobileCartContinueBtn"
    >
      Continue
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('cart', ['getCartProducts']),
		outOfStock () {
			let stock = false
			this.cartProducts.forEach((product) => {
				if (product.stock < 1 || product.product_id === null) {
					stock = true
				}
			})
			return stock
		}
	},
	props: {
		cartProducts: Array,
		cartTotal: {
			default: 0,
			type: Number
		},
		cartCount: {
			default: 0,
			type: Number
		}
	}
}
</script>
